<template>
    <div>
        <div style="height: 500px;">
            <example-description
                    subject="InfinitePaginationTable 은 Data Table 에 무한 페이징 기능을 자동으로 제공합니다."
                    content="서버 요청이나 같은 로직에 종속되지 않고 아이템 목록을 반환하는 메서드를 통해 자유롭게 사용할 수 있습니다."
            />
            <infinite-pagination-table
                    :next="next"
                    :headers="headers"
            >
            </infinite-pagination-table>

        </div>
    </div>
</template>

<script>
    import ExampleDescription from "@/components/example/ExampleDescription";
    import InfinitePaginationTable
        from "@/assets/plugins/mps-form-table/component/infinite-pagination-component-table/InfinitePaginationTable";

    export default {
        name: "ExampleInfinitePaginationTable",
        components: {InfinitePaginationTable, ExampleDescription},
        data() {
            return {
                headers: [
                    {
                        text: "아이디",
                        key: "id",
                        width: 100,
                    },
                    {
                        text: "내용",
                        key: "text",
                        width: 300,
                        editable: true,
                    },
                    {
                        text: "마지막 컬럼인 추가 내용은 window width 를 줄일시 헤더가 내려갑니다. window 사이즈를 조정해 보세요",
                        key: "additional",
                        width: 300,
                        editable: true,
                    },
                ],

                items: [],
            }
        },
        created() {
            for (let i = 0; i < 30; i++) {
                this.items.push({
                    id: "id" + i,
                    text: "테스트" + i,
                    additional: "추가 내용" + i,
                },);
            }
        },
        methods: {
            next() {
                return this.items;
            }
        }
    }
</script>

<style scoped>

</style>